import ExperienceLodging from './ExperienceLodging';

export default ExperienceLodging;
